
import Vue from 'vue';

// Creamos una nueva instancia de Vue que servirá como nuestro EventBus personalizado.
// Esto actúa como un sistema de eventos centralizado para permitir la comunicación entre componentes sin una relación directa.
const EventBus = new Vue();


export default EventBus;
